import { array } from 'fp-ts';
import { SimpleAmount, CommanderThunkAction, AsyncAction } from '@mews-commander/types';
import { CreditLimit } from '@mews-commander/data-access';
import { Identifiable } from '@mews/std';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { CREDIT_LIMIT_ADDED, CREDIT_LIMIT_UPDATED, setCreditLimits } from '../ducks/creditLimits';

type AddCreditLimits = Array<Omit<CreditLimit, 'id'>>;
type CreditLimitUpdates = Array<CreditLimitUpdate>;

interface CreditLimitUpdate extends Identifiable {
    amount: {
        value: SimpleAmount | null;
    };
}
interface AddCreditLimitsProps {
    creditLimits: AddCreditLimits;
}
interface UpdateCreditLimitsProps {
    creditLimits: CreditLimitUpdates;
}

export const addCreditLimits =
    ({ creditLimits }: AddCreditLimitsProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container }) => {
        const { creditLimitsComponent } = container();
        const promise = creditLimitsComponent
            .add({ creditLimits })
            .then((response: { creditLimits: Array<CreditLimit> }) => {
                if (array.isNonEmpty(response.creditLimits)) {
                    dispatch(setCreditLimits(response.creditLimits));
                }
            });
        return dispatch(createFetchAction(CREDIT_LIMIT_ADDED, promise));
    };

export const updateCreditLimits =
    ({ creditLimits }: UpdateCreditLimitsProps): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container }) => {
        const { creditLimitsComponent } = container();
        const promise = creditLimitsComponent
            .update({ creditLimits })
            .then((response: { creditLimits: Array<CreditLimit> }) => {
                if (notEmpty(response.creditLimits)) {
                    dispatch(setCreditLimits(response.creditLimits));
                }
            });
        return dispatch(createFetchAction(CREDIT_LIMIT_UPDATED, promise));
    };
